/* Google OAuth redirect bridge for the iOS app.
   Google only allows HTTPS redirect URIs on the Web OAuth client; this page
   forwards the authorization response to feedkiwi://youtube-callback. */

import { useEffect } from "react";
import { KiwiIcon } from "@/components/brand/KiwiIcon";

const IOS_CALLBACK_SCHEME = "feedkiwi://youtube-callback";

export function YouTubeIosOAuthCallbackPage() {
  useEffect(() => {
    const search = window.location.search;
    window.location.replace(`${IOS_CALLBACK_SCHEME}${search}`);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl p-8 max-w-md w-full text-center border border-border">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
          <KiwiIcon className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-xl font-semibold text-foreground mb-2">
          Returning to FeedKiwi…
        </h1>
        <p className="text-muted-foreground text-sm">
          If the app does not open automatically, switch back to FeedKiwi and try
          again.
        </p>
      </div>
    </div>
  );
}
